<div class="finish-page">

  <!-- Nav bar -->
  <div class="qr-back-header">
    <button nbButton ghost status="basic" size="small" (click)="goBack()">
      <nb-icon pack="eva" icon="arrow-back-outline"></nb-icon>
    </button>
    <div class="qr-back-info">
      <span class="qr-back-title">Wartung abschließen</span>
      <span class="qr-back-address">{{ context.section()?.buildingSectionAddress }}</span>
    </div>
  </div>

  @if (timer(); as t) {
    <nb-card class="timer-info-card">
      <nb-card-body>
        <div class="timer-info">
          <div
            class="days-badge"
            [class.overdue]="daysLeft() < 0"
            [class.soon]="daysLeft() <= 7 && daysLeft() >= 0"
            [class.ok]="daysLeft() > 7">
            {{ daysLeft() }} {{ daysLeft() | pluralize: 'Tag': 'Tage' }}
          </div>
          <div class="timer-name">{{ t.buildingEquipmentName }}</div>
          <div class="timer-date">Fällig: {{ t.nextDate | date: 'dd.MM.yyyy' }}</div>
        </div>
      </nb-card-body>
    </nb-card>

    <div class="form-body">

      <!-- Info card: name, comment, photos -->
      <nb-card class="info-card">
        <nb-card-header>Angaben zur Wartung</nb-card-header>
        <nb-card-body>
          <div class="info-fields">

            @if (!context.isExternal()) {
              <div class="field-group">
                <label class="field-label" for="qr-finish-name">Name <span class="required">*</span></label>
                <input
                  id="qr-finish-name"
                  nbInput
                  fullWidth
                  placeholder="Ihren Namen eingeben"
                  [value]="name()"
                  (input)="name.set($any($event.target).value)"
                  class="name-input"
                />
              </div>
            }

            <div class="field-group">
              <label class="field-label" for="qr-finish-comment">Kommentar</label>
              <textarea
                id="qr-finish-comment"
                nbInput
                fullWidth
                rows="3"
                placeholder="Kommentar eingeben (optional)"
                data-cy="qr-timer-finish-comment"
                [value]="comment()"
                (input)="comment.set($any($event.target).value)"
              ></textarea>
            </div>

            <div class="field-group">
              <span class="field-label">
                Bilder
                @if (t.imagesMandatory) {
                  <span class="required">*</span>
                }
              </span>
              <wr-multi-attachment-control [formControl]="attachmentsControl"></wr-multi-attachment-control>
            </div>

            @if (!context.isExternal()) {
              <div class="field-group">
                <nb-checkbox
                  [checked]="sendEmailToPropertyManager()"
                  (checkedChange)="sendEmailToPropertyManager.set($event)">
                  E-Mail an Hausverwalter schicken
                </nb-checkbox>
              </div>
            }

          </div>
        </nb-card-body>
      </nb-card>

      <!-- Protocol type selector -->
      @if (hasProtocolTypes()) {
        <div class="form-section">
          <span class="section-label">Protokoll (optional)</span>
          <div class="protocol-type-grid">
            @for (type of t.maintenanceProtocolTypes; track type.id) {
              <div
                class="protocol-type-card"
                [class.selected]="selectedProtocolType()?.id === type.id"
                role="button"
                tabindex="0"
                (click)="selectProtocolType(type)"
                (keydown.enter)="selectProtocolType(type)"
                (keydown.space)="selectProtocolType(type); $event.preventDefault()">
                <div class="type-accent" [style.background-color]="type.color || '#cccccc'"></div>
                <div class="type-info">
                  <span class="type-shortcut" [style.color]="type.color">{{ type.shortcut }}</span>
                  <span class="type-name">{{ type.name }}</span>
                </div>
                @if (selectedProtocolType()?.id === type.id) {
                  <nb-icon
                    icon="checkmark-circle-2-outline"
                    pack="eva"
                    class="type-check"
                    [style.color]="type.color">
                  </nb-icon>
                }
              </div>
            }
          </div>
        </div>
      }

      <!-- Protocol section stepper -->
      @if (selectedProtocolType() && preset() && totalSections() > 0) {

        <!-- Progress header -->
        <div class="stepper-header">
          <div class="stepper-progress">
            @for (s of sections(); track $index; let i = $index) {
              <div
                class="stepper-dot"
                [class.stepper-dot--active]="i === currentSectionIndex()"
                [class.stepper-dot--done]="i < currentSectionIndex()">
              </div>
            }
          </div>
          <div class="stepper-title">
            <span class="stepper-counter">Abschnitt {{ currentSectionIndex() + 1 }} von {{ totalSections() }}</span>
            @if (currentSection(); as current) {
              <span class="stepper-section-name">{{ current.collection.title }}</span>
            }
          </div>
        </div>

        <!-- All section forms kept in DOM; only current is visible -->
        <nb-card class="section-card">
          <nb-card-body>
            @for (section of sections(); track $index; let i = $index) {
              <div [style.display]="i === currentSectionIndex() ? '' : 'none'">
                <wr-custom-form
                  [collection]="section.collection"
                  [readonly]="false"
                  [singleColumn]="true">
                </wr-custom-form>
              </div>
            }
          </nb-card-body>
        </nb-card>

        <!-- Section navigation -->
        <div class="stepper-nav">
          <button nbButton status="basic" size="medium" [disabled]="isFirstSection()" (click)="prevSection()">
            <nb-icon icon="arrow-back-outline" pack="eva"></nb-icon>
            Zurück
          </button>
          @if (!isLastSection()) {
            <button nbButton status="primary" size="medium" (click)="nextSection()">
              Weiter
              <nb-icon icon="arrow-forward-outline" pack="eva"></nb-icon>
            </button>
          }
        </div>

      }

    </div>
  } @else {
    <div class="loading-hint">
      <nb-spinner></nb-spinner>
    </div>
  }

  <!-- Sticky submit bar -->
  <div class="submit-bar">
    <button
      nbButton
      status="success"
      size="large"
      fullWidth
      data-cy="qr-timer-finish-submit"
      [disabled]="submitting()"
      (click)="submit()">
      <nb-icon icon="checkmark-circle-2-outline" pack="eva"></nb-icon>
      {{ submitting() ? 'Wird gespeichert…' : 'Wartung abschließen' }}
    </button>
  </div>

</div>
